// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import Client from './client/reducers';

export default (combineReducers({
    Auth,
    Layout,
    Client,
}): any);
